import {
  Home,
  ClipboardList,
  PlusCircle,
  Store,
  Settings,
  UserCircle,
  BarChart3,
  Bell,
  Search,
  Menu,
  X,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  LogOut,
  Mail,
  Building2,
  Users,
} from 'lucide-react';
import type { IconName } from './types';

interface IconProps {
  name: IconName;
  className?: string;
  size?: number;
}

const iconMap = {
  home: Home,
  'clipboard-list': ClipboardList,
  'plus-circle': PlusCircle,
  'building-storefront': Store,
  cog: Settings,
  'user-circle': UserCircle,
  'chart-bar': BarChart3,
  bell: Bell,
  search: Search,
  menu: Menu,
  x: X,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-down': ChevronDown,
  'log-out': LogOut,
  mail: Mail,
  building: Building2,
  users: Users,
} as const;

export function Icon({ name, className = '', size = 20 }: IconProps) {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return <IconComponent className={className} size={size} />;
}
